import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Injectable } from '@angular/core';

@Injectable()
export class AlertService {
    constructor(public dialog: MatDialog) {

    }

    openAlert(titulo, mensagem) {
        let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
            width: '500px',
            data: { titulo: titulo, mensagem: mensagem }
        });
    }

}

@Component({
    selector: 'app-alert',
    template: `<h2 mat-dialog-title class="text-center">{{titulo}}</h2>
    <mat-dialog-content class="text-center">{{mensagem}}</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close class="float-right">Ok</button>
    </mat-dialog-actions>`,
    styleUrls: ['../assets/less/all.less']
})
export class DialogOverviewExampleDialog {
    titulo;
    mensagem;

    constructor(
        public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.titulo = data.titulo;
        this.mensagem = data.mensagem;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}